import React, { useState } from 'react'
import useGlobalTheme from '../../hooks/useGlobalTheme'

const FAQItem = ({ question, answer }) => {
	const [isOpen, setIsOpen] = useState(false)
	const theme = useGlobalTheme()
	const isLight = theme === 'light'

	return (
		<div className={`border-b ${isLight ? 'border-gray-200' : 'border-[#1d3f58]'}`}>
			<button
				className="flex justify-between items-center w-full py-4 text-left"
				onClick={() => setIsOpen(!isOpen)}
			>
				<span className={`text-lg font-semibold ${isLight ? 'text-gray-900' : 'text-[#eef3f9]'}`}>{question}</span>
				<span className={`text-xl ${isLight ? 'text-gray-500' : 'text-[#eef3f9]'}`}>{isOpen ? '-' : '+'}</span>
			</button>
			{isOpen && (
				<div className={`pb-4 ${isLight ? 'text-gray-600' : 'text-[#b3cde4]'}`}>
					<p className="text-md font-semibold">{answer}</p>
				</div>
			)}
		</div>
	)
}

const FAQ = () => {
	const theme = useGlobalTheme()
	const isLight = theme === 'light'

	const faqData = [
		{
			question: 'Which loadboards does LoadLine support?',
			answer:
				'Currently, LoadLine supports DAT One. We are working on adding support for other loadboards in the future.',
		},
		{
			question: 'What types of payment do you accept?',
			answer:
				'We accept payments through Stripe, which supports a wide range of global card networks.',
		},
		{
			question: 'What do you need to sign up?',
			answer: 'An active email address. That’s it!',
		},
		{
			question: 'How does your pricing work? Are there any hidden fees?',
			answer: 'Our pricing model is transparent with no hidden fees.',
		},
		{
			question: 'How often do you release new features or updates?',
			answer:
				'We consistently roll out new features and updates to enhance your experience.',
		},
		{
			question:
				'Is there a free trial available, and do I need a credit card to sign up?',
			answer:
				'Yes, we offer a 7-day free trial, which is available once per company. No credit card is required to sign up for the free trial.',
		},
		{
			question: 'How is LoadLine better than other solutions?',
			answer:
				'LoadLine offers unique features tailored specifically for DAT One users, providing a seamless and efficient workflow that other solutions may not offer.',
		},
	]

	return (
		<div className={isLight ? 'bg-white' : 'bg-[#001b2e]'}>
			<div className="container mx-auto px-4 sm:px-6 lg:px-8">
				<div className={`py-16 ${isLight ? 'bg-white' : 'bg-[#001b2e]'}`}>
					<div className="container mx-auto px-4">
						<div className="flex flex-col md:flex-row">
							<div className="md:w-1/2 pr-8 mb-8 md:mb-0">
								<h2 className={`text-3xl font-bold top-8 ${isLight ? 'text-gray-900' : 'text-[#eef3f9]'}`}>
									Frequently Asked Questions
								</h2>

								<p className={`mt-8 ${isLight ? 'text-gray-600' : 'text-[#b3cde4]'}`}>
									Have another question?
									<a
										href="https://t.me/loadlineai"
										className={`hover:underline ml-1 ${isLight ? 'text-blue-600' : 'text-blue-400'}`}
										target="_blank"
										rel="noopener noreferrer"
									>
										Contact Us
									</a>
									.
								</p>
							</div>
							<div className="md:w-1/2 space-y-4 ">
								{faqData.map((faq, index) => (
									<FAQItem
										key={index}
										question={faq.question}
										answer={faq.answer}
									/>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default FAQ
